import useReduxAction from '@hooks/useReduxAction'
import useUserRoles from '@hooks/useUserRoles'
import useServiceGroups from '@hooks/useServiceGroups'
import useServiceJobStatuses from '@hooks/useServiceJobStatuses'
import useNotificationTypes from '@hooks/useNotificationTypes'
import useActivityLogTypes from '@hooks/useActivityLogTypes'
import useServiceJobChecklistItemTypes from '@hooks/useServiceJobChecklistItemTypes'

const Studio = (props) => {
  const { children } = props

  useReduxAction('assetCommentTypes', 'loadAssetCommentTypes', {})
  useReduxAction('assetTypes', 'loadAssetTypes', {})
  useReduxAction('resourceTypes', 'loadResourceTypes', {})
  useReduxAction('vsirStatuses', 'loadVSIRStatuses', {})
  useReduxAction('wordReplacements', 'loadWordReplacements', {})
  useReduxAction('emailReplacements', 'loadEmailReplacements', {})
  useUserRoles({ performHttpRequests: true })
  useServiceGroups({ performHttpRequests: true })
  useServiceJobStatuses({ performHttpRequests: true })
  useNotificationTypes({ performHttpRequests: true })
  useActivityLogTypes({ performHttpRequests: true })
  useServiceJobChecklistItemTypes({ performHttpRequests: true })

  return children
}

export default Studio
